import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '../../services/RestApiService';


export type SetDataQualityTriggersForItemRequestParams = {
  readonly contentItemType: 'datasource';
  readonly contentItemLuid: string;
}

export function getSetDataQualityTriggersForItemRequestConfig(
  params: SetDataQualityTriggersForItemRequestParams
): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.10',
    httpMethod: 'POST',
    endpoint: `dataQualityTriggers/${params.contentItemType}/contentIds`,
    serverWideRequest: false,
  };
}

function makeQueryParams(params: SetDataQualityTriggersForItemRequestParams) {
  return {
    filter: `contentId:in:[${params.contentItemLuid}]`
  };
}

export type SetDataQualityTriggersForItemRequestBody = {
  readonly dataQualityTrigger: {
    readonly type: 'extract_refresh';
    readonly message: string;
    readonly active: boolean;
    readonly severe: boolean;
  };
};

export function callViaApiService(
  params: SetDataQualityTriggersForItemRequestParams & SetDataQualityTriggersForItemRequestBody
) {
  return makeJsonRestApiRequest<SetDataQualityTriggersForItemRequestBody, void>({
    config: getSetDataQualityTriggersForItemRequestConfig(params),
    request: { dataQualityTrigger: params.dataQualityTrigger },
    queryParams: makeQueryParams(params),
  });
}
